import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { BookOpen, Mail, FileText, Sparkles, Zap } from "lucide-react";
import { ICON_MAP, FADE_UP } from "./contentModel";

const Stat = ({ Icon, children, accent }) => (
  <span className={`text-xs flex items-center gap-1 ${accent ? "text-ism-teal" : "text-gray-500"}`}><Icon className="h-3 w-3" />{children}</span>
);

export const ContentCard = ({ item, index, onPersonalize }) => {
  const Icon = ICON_MAP[item.type] || FileText;
  return (
    <motion.div {...FADE_UP} transition={{ delay: index * 0.05 }}>
      <Card className="glass-card hover:border-ism-teal/30 transition-all p-5">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-ism-teal/10 flex items-center justify-center flex-shrink-0 border border-ism-teal/20">
            <Icon className="h-6 w-6 text-ism-teal" />
          </div>
          <div className="flex-1 min-w-0">
            <Badge className="bg-white/5 text-gray-400 border-white/10 text-xs mb-2">{item.type}</Badge>
            <h3 className="text-white font-medium truncate">{item.title}</h3>
            <p className="text-gray-400 text-sm mt-1 line-clamp-2">{item.description}</p>
            {item.tags?.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-3">
                {item.tags.slice(0, 3).map((tag) => <Badge key={tag} className="bg-ism-teal/10 text-ism-teal border-ism-teal/20 text-xs">{tag}</Badge>)}
              </div>
            )}
            <div className="flex items-center gap-4 mt-4 pt-3 border-t border-white/5">
              <Stat Icon={BookOpen}>{item.views || 0} views</Stat>
              <Stat Icon={Mail}>{item.sends || 0} sends</Stat>
              {item.engagement > 0 && <Stat Icon={Zap} accent>{item.engagement}%</Stat>}
            </div>
          </div>
        </div>
        <div className="mt-4 flex gap-2">
          <Button size="sm" onClick={() => onPersonalize(item)} data-testid={`personalize-btn-${index}`} className="flex-1 bg-ism-teal/10 hover:bg-ism-teal/20 text-ism-teal border border-ism-teal/20">
            <Sparkles className="h-3 w-3 mr-1" />
            Personalize
          </Button>
        </div>
      </Card>
    </motion.div>
  );
};
